import React, { useState } from 'react';

const FactoringCalculator = () => {
  const [input, setInput] = useState('');
  const [result, setResult] = useState(null);

  const factorize = () => {
    const num = parseFloat(input);
    if (isNaN(num)) {
      setResult(null);
      return;
    }

    const rationalForm = simplifyFraction(num);
    const continuedFraction = getContinuedFraction(num);
    const closedForms = getClosedForms(num);

    setResult({ input: num, rationalForm, continuedFraction, closedForms });
  };

  const simplifyFraction = (num) => {
    const denominator = 1000;
    const numerator = Math.round(num * denominator);
    const gcd = (a, b) => (b === 0 ? a : gcd(b, a % b));
    const divisor = gcd(numerator, denominator);
    return `${numerator / divisor} / ${denominator / divisor}`;
  };

  const getContinuedFraction = (x) => {
    const cf = [];
    let q = Math.floor(x);
    cf.push(q);
    let r = x - q;
    let count = 0;
    while (r !== 0 && count < 10) {
      x = 1 / r;
      q = Math.floor(x);
      cf.push(q);
      r = x - q;
      count++;
    }
    return `[${cf.join('; ')}]`;
  };

  const getClosedForms = (num) => {
    const pi = Math.PI;
    const logPi = Math.log(pi);
    return [
      `18π ≈ ${(18 * pi).toFixed(10)}`,
      `5π² × log(π) ≈ ${(5 * pi * pi * logPi).toFixed(10)}`,
    ];
  };

  return (
    <div className="min-h-screen bg-[#02042b] text-white flex flex-col items-center justify-start py-12 px-4">
      <h1 className="text-3xl font-bold mb-6">📊 Free Factoring Calculator</h1>
      <input
        type="text"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        placeholder="Enter a number or equation..."
        className="w-full max-w-xl p-4 text-black rounded-md mb-4"
      />
      <button
        onClick={factorize}
        className="bg-orange-500 px-6 py-2 rounded font-semibold text-white hover:bg-orange-600"
      >
        Factorize It
      </button>

      {result && (
        <div className="w-full max-w-3xl mt-10 bg-white/10 backdrop-blur-lg p-6 rounded-lg border border-white/20">
          <h2 className="text-xl font-bold mb-4">Answer:</h2>
          <p><strong>Input:</strong> {result.input}</p>
          <p className="mt-2"><strong>Rational form:</strong> {result.rationalForm}</p>
          <p className="mt-2"><strong>Continued fraction:</strong> {result.continuedFraction}</p>
          <p className="mt-2"><strong>Possible closed forms:</strong></p>
          <ul className="list-disc list-inside text-green-300">
            {result.closedForms.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default FactoringCalculator;
